export default "__VITE_ASSET__CykGjHjt__"